module.exports = __webpack_public_path__ + "img/dne-pay-white.907c3745.svg";